import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! RESPONSIBLE TEAM: team-frontend-tech }}\n{{outlet}}",{ moduleName: "embercom/templates/apps/app/impersonate.hbs" })